module.exports = require("lodash/mapValues");


//////////////////
// WEBPACK FOOTER
// external "lodash/mapValues"
// module id = 22
// module chunks = 0